import { PhoneNumberValidator } from './phone-number-validator.js';

export class HungarianPhoneNumberValidator extends PhoneNumberValidator {
  static readonly formattedPhoneNumberFormat: RegExp = new RegExp('^(?:\\+36|06)?(?:[0-9]\\d{7,8})$');
  static readonly phoneNumberFormat: RegExp = new RegExp('^[0-9]\\d{7,8}$');

  validateFormattedNumber(number: string | null): boolean {
    const sanitizedNumber = number?.replace(' ', '');
    return sanitizedNumber ? HungarianPhoneNumberValidator.formattedPhoneNumberFormat.test(sanitizedNumber) : false;
  }

  validate(number: string): boolean {
    const sanitizedNumber = this.sanitize(number);
    return sanitizedNumber ? HungarianPhoneNumberValidator.phoneNumberFormat.test(sanitizedNumber) : false;
  }

  sanitize(number: string): string | null {
    let sanitizedNumber = super.sanitize(number);
    if(sanitizedNumber) {
      if(sanitizedNumber.startsWith('+36')) {
        sanitizedNumber = sanitizedNumber.substring(3);
      }
      if(sanitizedNumber.startsWith('06')) {
        sanitizedNumber = sanitizedNumber.substring(2);
      }
    }

    return sanitizedNumber;
  }
}
